import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import { displayBooleanString } from 'ctm-util-functions';
import { SummaryTable } from '../summary_table';

const path = 'factory_options';

const _SummaryAccessories = (props) => {
    const { factoryOptions, nonStandardAccessories, modified, isUpdated } = props;

    const hasNonStandardAccessories = !!nonStandardAccessories && nonStandardAccessories.size > 0;
    const hasFactoryOptions = !!factoryOptions && factoryOptions.size > 0;

    const accessories = [
        {
            title: 'Factory options',
            value: displayBooleanString(hasFactoryOptions)
        },
        {
            title: 'Non-standard accessories',
            value: displayBooleanString(hasNonStandardAccessories)
        },
        {
            title: 'Modified',
            value: displayBooleanString(modified) ?? 'No'
        }
    ];

    return (
        <SummaryTable
            isUpdated={isUpdated}
            path={path}
            titleLabel={`Accessories ${isUpdated ? '- Updated' : ''}`}
            tableContent={accessories}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        factoryOptions: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'factoryOptions']),
        nonStandardAccessories: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'nonStandardAccessories']),
        modified: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'modified']),
        isUpdated: state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`])
    };
};

_SummaryAccessories.propTypes = {
    factoryOptions: PropTypes.string,
    nonStandardAccessories: PropTypes.string,
    modified: PropTypes.string,
    isUpdated: PropTypes.bool
};

const SummaryAccessories = connect(
    mapStateToProps,
)(_SummaryAccessories);

export { _SummaryAccessories, SummaryAccessories };
